import { useDispatch, useSelector } from "react-redux";

import Button from "../../components/Button/Button";
import { deliverySuccessMessage } from "../../utils/toastMessage/toastMessage";
import { setAuthAction } from "../../redux/actions/authActions/authActions";

const BackToAdmin = () => {
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);

  const isBackToAdmin = !!localStorage.getItem("adminToken");

  const handleBackToAdmin = () => {
    const accessToken = localStorage.getItem("adminToken");
    localStorage.removeItem("adminToken");
    dispatch(setAuthAction(accessToken));
    deliverySuccessMessage("شما با موفقیت وارد پنل مدیریت شدید", "/", "3000");
  };

  if (!isBackToAdmin || auth.isAdmin) return null;

  return (
    <div>
      <Button color="primary" onClick={handleBackToAdmin}>
        بازگشت به پنل مدیریت
      </Button>
    </div>
  );
};

export default BackToAdmin;
